import { call, put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';

export function* scrubTrack({ payload: { relativeValue, value, callback } }) {
  try {
    const wasPlaying = yield select(getInDomain('playback.utils.isAudioPlayerPlaying', false));
    const currentTime = yield select(getInDomain('playback.utils.getCurrentTrackTime'));
    const scrubTo = relativeValue ? currentTime + relativeValue : value;

    if (wasPlaying) {
      yield put(getInDomain('playback.actions.pauseSource')());
    }

    yield call(putAndWait, Actions.AudioPlayer.scrubAudio(scrubTo));
  } finally {
    callback();
  }
}
